import React, { useEffect, useState } from "react";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import { httpGetOnboardingDuration } from "../../../../service/httpClient";
import "./style.css";

const VendorProfileHeader = (props) => {
  const [inProcessDuration, setInProcessDuration] = useState("");
  const [onHoldDuration, setOnHoldDuration] = useState("");
  const [obCompleteDuration, setObCompleteDuration] = useState("");

  useEffect(() => {
    httpGetOnboardingDuration(localStorage.getItem("vid"))
      .then((res) => {
        setInProcessDuration(res.data.inProcessDuration);
        setOnHoldDuration(res.data.onHoldDuration);
        setObCompleteDuration(res.data.obCompleteDuration);
      })
      .catch(function(err) {
        setInProcessDuration("");
        setOnHoldDuration("");
        setObCompleteDuration("");
        return err.response;
      });
  }, []);

  return (
    <div className="col-md-12">
      <div className="flexContainer" style={{ flexWrap: "wrap" }}>
        {getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_PREBOARDING_VENDORPROFILE,
          RolePermissionConstants.ALL
        ) !== RolePermissionConstants.NONE && (
          <div className="flexChild" style={{ marginLeft: "-10px" }}>
            <div className="vendor-status-info">
              <div className="text-center">
                <b>Key Dates</b>
              </div>
              <ul>
                <li>
                  Integration Start Date: {props.profileHeaderVar.intDate}
                </li>
                <li>Hold Date: {props.profileHeaderVar.holdDate}</li>
              </ul>
            </div>

            <div className="vendor-status-info">
              <div className="text-center">
                <b>Onboarding Duration (# of days)</b>
              </div>
              <ul>
                <li>In Process: {inProcessDuration}</li>
                <li>On Hold: {onHoldDuration}</li>
                <li>OB Complete: {obCompleteDuration}</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorProfileHeader;
